import {
    Column
} from 'devextreme-react/data-grid';

import { LoadPagePanel, SyncDataGrid } from '../../../../components';
import { useGetAssignedDistributors } from '../api/get-assigned-distributors';
import { useAuth } from '../../../../contexts/auth';

export default function AssignedDistributorsGrid() {

    const { user } = useAuth();
    const Distributors = useGetAssignedDistributors(user?.companyId!);

    return (
        <>
            <SyncDataGrid
                stateStorageKey='assigned-distributors-grid'
                className={'dx-card wide-card'}
                dataSource={Distributors.data}
                keyExpr={'distributorAssignmentID'}
            >
                <Column
                    dataField={'distributor'}
                    caption={'Distributor Name'}
                    dataType="string"
                />
                <Column
                    dataField={'productLine'}
                    caption={'Product Line'}
                    dataType="string"
                />
                <Column
                    dataField={'productCategory'}
                    caption={'Product Category'}
                    dataType="string"
                />
                <Column
                    dataField={'location'}
                    caption={'Location'}
                    dataType="string"
                />
                <Column
                    dataField={'distributorPhone'}
                    caption={'Phone Number'}
                    dataType="string"
                />
                <Column
                    dataField={'distributorAddress'}
                    caption={'Address'}
                    dataType="string"
                />
            </SyncDataGrid>

            <LoadPagePanel visible={Distributors.isLoading} />
        </>
    )
} 
